import { POC_SITE_TYPE, POC_SUB_SITE_TYPE, POC_TYPE, ALL_CLIENT, CLIENT_BUSINESS, BUSINESS_DETAILS } from "./type";

const initalState = {
  pocTypeData: [],
  pocSiteTypeData: [],
  pocSubSiteTypeData: [],
  getAllClient: [],
  clientBusiness: [],
  businessDetail: []
};

const pocTypesReducer = (state = initalState, action) => {
  const { type, payload } = action;
  switch (type) {
    case POC_TYPE:
      return {
        ...state,
        pocTypeData: payload,
      };
    case POC_SITE_TYPE:
      return {
        ...state,
        pocSiteTypeData: payload,
      };
    case POC_SUB_SITE_TYPE:
      return {
        ...state,
        pocSubSiteTypeData: payload,
      };
    case ALL_CLIENT:
      return {
        ...state,
        getAllClient: payload,
      };
    case CLIENT_BUSINESS:
      return {
        ...state,
        clientBusiness: payload,
      }
    case BUSINESS_DETAILS:
      return{
        ...state,
        businessDetail: payload,
      };
    default:
      return {
        ...state,
      };
  }
};

export default pocTypesReducer;
